/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Status/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Active from './Active/index'
import Inactive from './Inactive/index'
import No from './No/index'
import NotInvited from './NotInvited/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Status({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/PracticeHub/Status"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let patientPersonPublicUserValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'person.public_user',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: patientPersonPublicUserValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Active'}>
<Active
  viewPath={`${viewPath}/Active`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Inactive'}>
<Inactive
  viewPath={`${viewPath}/Inactive`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NotInvited'}>
<NotInvited
  viewPath={`${viewPath}/NotInvited`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}